<template>
	<div>
		<v-card-text class="pa-0" style="height: 500px; overflow-y: auto;">
			<v-layout class="pa-2" row wrap style="height: auto;" v-if="instance">
				<v-flex xs6 style="padding-bottom: 5px;" pr-1>
					<v-select
	        	:items="instance_types"
	        	v-model="instance.type"
	        	label="Type"
	        	item-text="label"
	        	item-value="value">
	      	</v-select>
					<v-text-field v-model="instance.title" label="Title"></v-text-field>

					<v-autocomplete
						:items="channels"
						v-model="instance.meta.channel"
						label="Channel"
						item-text="title"
						item-value="uuid"
						:hint="channel_hint"
						:persistent-hint="true"
						v-if="is_channel_instance">
					</v-autocomplete>

					<div v-if="is_headend_instance">
						<v-checkbox label="Previews" v-model="instance.meta.preview" color="orange darken-3" hide-details></v-checkbox>
						 <v-select label="Preview config" :items="preview_configurations" v-model="instance.meta.preview_config" item-text="name" item-value="name">
	           </v-select>
					</div>

					<v-text-field v-if="id" :value="instance.token" readonly label="Token" @click="$event.target.select()"></v-text-field>

					<div style="width: 220px; height: 220px; background-color: white;">
						<qrcode-vue v-if="is_input_instance" v-on:click.native='openGroveUrl()' :value="this.createGroveUrl()" :size="200" style="padding: 10px;"></qrcode-vue>
					</div>

				</v-flex>
				<v-flex xs6 style="padding-bottom: 5px;" pr-1>
					<json-editor v-model="instance.meta"></json-editor>
				
					<v-checkbox label="Developer instance" v-model="instance.meta.is_developer" hide-details color="orange darken-3"></v-checkbox>

				</v-flex>
			</v-layout>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn v-if="is_transcoder_instance && is_edit" color="error" @click="stop_transcoder">Stop</v-btn>
			<v-btn color="error" @click="remove" v-if="$is_privilege(['root', 'developer'])">Remove</v-btn>
			<v-btn flat @click="reset">Reset</v-btn>
			<v-btn color="success" @click="save(false)">Save</v-btn>
			<v-btn color="success" @click="save(true)">Save and close</v-btn>
		</v-card-actions>
	</div>
</template>

<script>
import JsonEditor from '@/components/JsonEditor';
import SettingsModel from '@/models/settings.js';
import InstanceModel from '@/models/instance.js';
import ChannelModel from '@/models/channel.js';
import QrcodeVue from 'qrcode.vue';

export default {
	props: ["id"],
	components: {
		JsonEditor,
		QrcodeVue
	},
	data () {
		var ch = this.$cloudserver.channel("instances:"+(this.id||"create"));
		return {
			ws_channel: ch,
			instance: this.convertInstance(ch.data),
			instance_types: InstanceModel.types()
		}
	},
	watch: {
		"ws_channel.data": {
			handler(newVal, oldVal) {
				if(typeof(newVal) != "undefined") {
					this.instance = this.convertInstance(newVal, oldVal);
				}
			},
			deep: true
		},
		'$route' (to, from) {
			if(typeof(from.meta.edit) != "undefined" && to.name == from.meta.edit) {
				this.ws_channel = this.$cloudserver.channel("instances:"+(this.id||"create"));
				this.ws_channel.join();
			}
		}
	},
	created() {
	  this.ws_channel.join();
	},
	computed: {
		is_edit () {
			return typeof(this.instance) != "undefined" && this.instance.id != null;
		},
		is_channel_instance () {
			return InstanceModel.is_type_channel(this.instance);
		},
		is_headend_instance () {
			return InstanceModel.is_type_headend(this.instance);
		},
		is_transcoder_instance() {
			return InstanceModel.is_type_transcoder(this.instance);
		},
		is_input_instance() {
			return InstanceModel.is_type_input_channel(this.instance);
		},
		channels () {
			var channels = [];
			if (this.instance.type == "input") channels = this.$store.getters.input_channels;
			if (this.instance.type == "output") channels = this.$store.getters.output_channels;
			return _.filter(channels, (channel) => { return channel.state == "active"; });
		},
		preview_configurations () {
			return SettingsModel.list("headend_preview");
    },
		channel_hint() {
			var channel = this.instance.meta.channel;
			var instance = InstanceModel.get_instance(this.instance.id);
			if(_.isEmpty(instance)) return "";
			if(instance.meta.channel == channel) {
				return "";
			}
			var ch = ChannelModel.channel_by_uuid(instance.meta.channel);
			if(_.isEmpty(ch)) return "";
			return "The channel \""+ch.title+"\" will be removed from this instance.";
		}
	},
	methods: {
		convertInstance (newVal, oldVal) {
			var instance = _.cloneDeep(newVal);
			if(typeof(oldVal) != "undefined") {
				//TODO: Tähän muuttuneen datan tarkistus ja ilmoitus
			}

			if(typeof(instance) == "undefined" || _.isEmpty(instance)) return undefined;
			return instance;
		},
		reset () {
			this.instance = this.convertInstance(this.ws_channel.data);
		},
		stop_transcoder () {
			var self = this;
			InstanceModel.stop_transcoder(this.instance, (msg) => {
				self.$message.success("Transcoder stopped");
				self.$root.close_bottom_sheet();
			}, (err) => {
				self.$message.succes("Cannot stop transcoder")
			});
		},
		remove () {
			if(!confirm("Do you really want remove instance?\nInstance: "+InstanceModel.title(this.instance))) return;
			var self = this;
			if (typeof(this.ws_channel) != "undefined") {
				this.ws_channel.push("delete", {instance_id: this.id})
				.receive("ok", (msg) => {
					self.$message.success("Instance was removed!");
					self.$root.close_bottom_sheet();
				})
				.receive("error", (msg) => {
					self.$message.warning("Unable to remove instance!");
				})
				.receive("timeout", (msg) => {
					self.$message.warning("Unable to remove instance!");
				});
			}
		},
		save (close) {
			var self = this;
      if (typeof(this.ws_channel) != "undefined") {
      	var instance = _.cloneDeep(this.instance);

				var old_instance = InstanceModel.get_instance(this.instance.id);
				if(!_.isEmpty(old_instance) && old_instance.meta.channel != instance.meta.channel) {
					var ch = ChannelModel.channel_by_uuid(old_instance.meta.channel);
					if(!_.isEmpty(ch) && !confirm("The channel \""+ch.title+"\" will be removed from this instance.\nAre you sure?")) {
						return;
					}
				}

				this.ws_channel.save({instance: instance})
					.then((msg) => {
						if (typeof(self.id) == "undefined") {
							self.$message.success("Instance was created!");
						} else {
							self.$message.success("Instance was updated!");
						}
						if(close) {
              self.$root.close_bottom_sheet();
            } else if(typeof(self.id) == "undefined" && typeof(this.$route.meta.edit) != "undefined") {
              this.$router.push({name: this.$route.meta.edit, params: {id: msg.data.id}})
            }
					})
					.catch((msg) => {
						console.log(msg);
						if (typeof(self.id) == "undefined") {
							self.$message.warning("Unable to create instance!");
						} else {
							self.$message.warning("Unable to update instance!");
						}
					});
      }
		},
		createGroveUrl () {
			return "larix://set/v1?token=" + this.instance.token;
		},
		openGroveUrl () {
			window.open("larix://set/v1?token=" + this.instance.token);
		}
	}
}
</script>
